export default "__VITE_ASSET__b5523ba5__"